import { cva } from 'class-variance-authority';

export const containerVariants = cva(
  // `min-w-0` so a call site that constrains the button's width (e.g.
  // `className="min-w-0"` on a flex row) can actually shrink it; without it
  // the flex chain floors at the label's min-content width and overflows.
  'flex w-[inherit] items-center pointer-events-none min-w-0',
  {
    variants: {
      size: {
        tiny: '',
        small: '',
        medium: '',
      },
      loading: {
        true: 'justify-center',
        false: '',
      },
      contentDirection: {
        horizontal: '',
        vertical: 'flex-col',
      },
    },
    compoundVariants: [
      {
        contentDirection: 'horizontal',
        size: 'tiny',
        className: 'gap-spacing-comp-button-tiny-gap',
      },
      {
        contentDirection: 'horizontal',
        size: 'small',
        className: 'gap-spacing-comp-button-small-gap',
      },
      {
        contentDirection: 'horizontal',
        size: 'medium',
        className: 'gap-spacing-comp-button-medium-gap',
      },
    ],
    defaultVariants: {
      contentDirection: 'horizontal',
      loading: false,
    },
  },
);
